import { render, staticRenderFns } from "./nextBtn.vue?vue&type=template&id=77b593a2&"
import script from "./nextBtn.vue?vue&type=script&lang=js&"
export * from "./nextBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports